import React from 'react';
import PropTypes from 'prop-types';

const GB = props => {

  return (
    <svg
      width={40}
      height={40}
      preserveAspectRatio="xMidYMid slice"
      clipRule="evenodd"
      fillRule="evenodd"
      viewBox="0 0 560 400"
      xmlns="http://www.w3.org/2000/svg"
      id="Packers"
    >
      <path
        d="m279.191 100.006c-82.129.007-151.515 46.036-151.515 100.517 0 56.715 65.142 99.482 151.515 99.482 50.41 0 98.206-17.718 127.854-47.393 16.322-16.331 25.296-34.835 25.279-52.089-.022-26.862-15.825-52.094-44.495-71.052-28.748-19.005-67.324-29.465-108.637-29.465"
        fill="#ffb612"
      />
      <path
        d="m173.235 267.135c-26.352-17.575-40.867-41.239-40.867-66.618 0-51.043 68.611-95.821 146.823-95.827 81.806-.004 148.393 42.985 148.442 95.827.013 16.01-8.476 33.329-23.909 48.773-28.784 28.811-75.337 46.016-124.533 46.016-41.101 0-78.733-10.01-105.956-28.174"
        fill="#203731"
      />
      <path
        d="m344.929 174.185c-11.794-17.569-37.621-29.753-68.032-29.753-41.738 0-75.584 22.96-75.584 51.276s23.891 53.178 75.584 53.149c31.044-.013 56.002-13.42 67.663-31.031l-88.173.154-.272-22.907 153.061-.053c.207 1.837.421 3.626.421 5.487 0 44.09-58.383 79.829-130.395 79.829-72.007 0-130.386-35.737-130.386-79.829 0-44.088 61.844-81.18 130.386-81.448 57.053-.216 105.548 23.357 123.235 55.087l-57.503.036"
        fill="#fff"
      />
    </svg>
  );
};

GB.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

GB.defaultProps = {
  size: '100'
};

export default GB;
